module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navContainer"
  }, [_c("HistoryRecord", {
    tag: "div"
  }), _vm._v(" "), _c("ListNav", {
    tag: "div"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41ab1ca4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/NavContainer.vue
// module id = 854
// module chunks = 5